import Module from '../../../../layout/Module';
import HeaderContent from './HeaderContent/HeaderContent';
import StudentDistribution from './StudentDistribution/StudentDistribution';
import { Route, Routes } from 'react-router-dom';
import { GroupStudentsContextProvider } from "./GroupStudentsContext/GroupStudentsContext";

const GroupStudents = () => {
  return (
    <GroupStudentsContextProvider>
      <HeaderContent />
      <Module.BodyContainer classNameWrapper='overflow-auto'>
        <Routes>
          <Route index path='/' element={<StudentDistribution />} />
        </Routes>
      </Module.BodyContainer>
    </GroupStudentsContextProvider>
  );
};

export default GroupStudents;
